
import CryptoJS from "crypto-js";

interface CryptoProps{
    pattern?:"AES",
    proce?:"decrypt"|"encrypt",
    data:string,
    key?:string
}


export const Crypto=({
    key=process.env.CRYPTO_KEY||"#",
    pattern="AES",
    proce="encrypt",
    ...props
}:CryptoProps):string=>{
    
    if(proce==="encrypt")
        return CryptoJS[pattern][proce](props.data||"",key).toString();
    else 
        return CryptoJS[pattern][proce](props.data||"",key).toString(CryptoJS.enc.Utf8);
}